import { BrowserRouter } from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'
import { SpeedInsights } from '@vercel/speed-insights/react'
import AppRoutes from './AppRoutes'
import { redactAnalyticsUrl } from './lib/analyticsRedaction'

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
      {/* beforeSend strips invite tokens and session ids from the recorded URL —
          Web Analytics records the raw path and query otherwise. See
          lib/analyticsRedaction.ts. */}
      <Analytics beforeSend={(event) => ({ ...event, url: redactAnalyticsUrl(event.url) })} />
      <SpeedInsights />
    </BrowserRouter>
  )
}
